import { render, staticRenderFns } from "./RootTipiContrattoView.vue?vue&type=template&id=39400b8d&"
import script from "./RootTipiContrattoView.vue?vue&type=script&lang=ts&"
export * from "./RootTipiContrattoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports